import { useEffect, useState } from 'react';

import { Button, DialogTitle, Grid, Chip, CircularProgress, Divider, Alert } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';

import { StandardDialogActions, RoundedDialog, SearchMenu } from '../../../../Global/Components';
import axios from 'axios';
import StateManager from '../../../../Global/StateManager';
import Iconify from '../../../../iconify';
import { uniq } from 'lodash';
import CreateTaskAllocationDialog from './AllocationTask';

const LocationSelectDialog = ({
  open,
  onClose,
  onDone,
  saving,
  initial,
  editable,
  title = 'Locations',
  buttonText = 'Pick Location to Add',
  forFilter,
  documentId,
}) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState([]);
  const [locationsMenu, setLocationsMenu] = useState(null);
  const [children, setChildren] = useState([]);
  const [taskDialog, setTaskDialog] = useState(false);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleChildren = (childIds) => {
    const all = uniq([...children, ...childIds]);
    setChildren(all);
  };

  const saveLocation = (item) => {
    setLocationsMenu(null);
    // add location to the list
    handleToggle(item._id);
    handleChildren(item.children?.map((x) => x._id));
  };

  useEffect(() => {
    if (!open) return;
    setChecked(initial || []);
    axios
      .get('dochub/locations?withHeriarchy=true')
      .then((res) => {
        setLocations(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        StateManager.setAxiosErrorAlert(err);
      });
  }, [open, initial]);

  if (loading) {
    return (
      <RoundedDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogContent>
          <Grid container justifyContent="center" alignItems="center" sx={{ p: 2 }}>
            <CircularProgress size={30} />
          </Grid>
        </DialogContent>
      </RoundedDialog>
    );
  }

  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {!forFilter && (
          <Grid container sx={{ width: '100%' }}>
            <Alert severity="info" icon={<Iconify icon="eva:info-outline" />} sx={{ mb: 1, width: '100%' }}>
              Locations you select will be the active locations for the document(s)
            </Alert>
          </Grid>
        )}
        <Grid container mt={1} gap={2} mb={1}>
          {locations
            ?.filter((x) => checked?.includes(x._id))
            ?.map((location) => (
              <Grid item key={location._id} mb={1}>
                <Chip
                  label={location.path}
                  onDelete={editable ? () => handleToggle(location._id) : null}
                  color="primary"
                  sx={{
                    background: location.color,
                    color: location.color ? (theme) => theme.palette.getContrastText(location.color) : '',
                  }}
                />
              </Grid>
            ))}
        </Grid>
        {editable && <Divider my={1} />}
        {editable && (
          <Grid container mt={1} gap={2} mb={1}>
            <Button variant="soft" onClick={(e) => setLocationsMenu(e.currentTarget)}>
              {buttonText}
            </Button>
            <SearchMenu
              anchorEl={locationsMenu}
              open={Boolean(locationsMenu)}
              onClose={() => setLocationsMenu(null)}
              idField="_id"
              textField="title"
              items={locations}
              onResult={saveLocation}
              map={(x) => x}
              loading={loading}
            />
            <Button
              variant="soft"
              color="primary"
              onClick={() => setTaskDialog(true)}
              startIcon={<Iconify icon="fluent:tasks-app-20-filled" />}
            >
              Create allocation task
            </Button>
          </Grid>
        )}
      </DialogContent>
      <StandardDialogActions
        onClose={onClose}
        onDone={() => onDone(checked, forFilter ? children : null)}
        disableDone={saving}
        saving={saving}
      />
      <CreateTaskAllocationDialog
        open={taskDialog}
        onClose={() => setTaskDialog(false)}
        initial={checked}
        documentId={documentId}
      />
    </RoundedDialog>
  );
};
export default LocationSelectDialog;
